import React, { useEffect } from "react"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { isInPosDevice, onlyPositiveNumber } from "utils"
import classes from "./ApprovePaymentModalCashTypes.module.scss"

const CheckoutCashTypes = props => {
  const {
    cashTypes,
    setCashTypes,
    paymentScrollRef,
    totalSelectedOrders,
    numberOfSelectedOrders,
    setFocusedCashType
  } = props

  const i18n = useTranslation()[1]

  const systemCashTypes =
    useSelector(state => state.systemSettings.cashTypes)

  const getAllCashTypes = () => {
    const results =
      systemCashTypes.map(systemCashType => ({
        name: systemCashType,
        value: systemCashType,
        terminalName: "",
        isTerminal: false
      }))

    if (isInPosDevice()) {
      results.push({
        name: "کارتخوان",
        value: window.posName === "bpMellat" ? "کارتخوان به پرداخت" : "کارتخوان سداد",
        terminalName: "",
        isTerminal: false
      })
    }

    return results
  }

  const handleAddPaymentType = (cashType) => {
    setCashTypes(prev => {
      const exists =
        prev.some(c => c.value === cashType.value)

      if (numberOfSelectedOrders === 1) {
        if (exists) return prev.filter(c => c.value !== cashType.value)

        if (prev.length === 2) return prev

        const totalCashTypesAmount =
          prev.reduce((t, c) => t += Number(c.amount), 0)

        const residue =
          onlyPositiveNumber(
            totalSelectedOrders - totalCashTypesAmount
          )

        setFocusedCashType(1)

        return [
          ...prev,
          {
            amount: residue === 0 ? 0 : Number(residue).toFixed(2),
            name: cashType.name,
            value: cashType.value,
            terminalName: cashType.terminalName,
            isTerminal: cashType.isTerminal
          }
        ]
      }

      if (exists) return prev

      setFocusedCashType(0)

      return [{
        amount: totalSelectedOrders,
        name: cashType.name,
        value: cashType.value,
        terminalName: cashType.terminalName,
        isTerminal: cashType.isTerminal
      }]
    })

    !!paymentScrollRef.current.scrollTo &&
      paymentScrollRef.current.scrollTo({
        left: 0,
        top: 100000,
        behaviour: "smooth"
      })
  }

  const initialCashtype = () => {
    setCashTypes([{
      amount: totalSelectedOrders,
      name: "نقدی",
      value: "نقدی",
      terminalName: "",
      isTerminal: false
    }])
  }

  useEffect(() => {
    initialCashtype()
  }, [])

  const allCashTypes = getAllCashTypes()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      {allCashTypes.map((cashtype, cIndex) => {
        const active =
          cashTypes.some(c => c.value === cashtype.value)

        return (
          <button
            key={cIndex}
            onClick={() => handleAddPaymentType(cashtype)}
            className={clsx(
              classes["cash-type"],
              isLtr && classes["cash-type-ltr"],
              active && classes["active"]
            )}
          >
            {cashtype.name}
          </button>
        )
      })}
    </div>
  )
}

export default React.memo(CheckoutCashTypes)
